<template>
   <div class='NuevaPropuesta'>
        <button class="btn btn-secondary btn-block" v-if="!cargando" @click="validarMembresia(idProyecto)">
            Hacer Propuesta
        </button>
        <button class="btn btn-secondary btn-block" v-else disabled>
            Cargando...
        </button>

        <!--Modal Postularte-->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header orange">
                <span>Haga una oferta para el proyecto:</span>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit="altaPropuesta">
                <div class="modal-body">
                <h4 class="text-center">{{nombre}}</h4>
                <hr>
                <div class="alert alert-warning" role="alert" v-show="membresia.vencido == 1 && membresia.valida == 0">
                    Lo sentimos, tu membresía es {{ membresia.tipo }} por lo que no puedes hacer una oferta para este proyecto.
                    Para poder hacer una oferta puedes hacer un <a href="#" @click="cerrarModal()">Upgrade</a> a tu membresia.
                </div>

                <div class="alert alert-warning" role="alert" v-show="membresia.vencido == 0">
                    Tu membresía vencio el {{ membresia.fecha_fin }} por lo que no puedes hacer una oferta para este proyecto.
                    Para poder hacer una oferta puedes hacer un <a href="#" @click="cerrarModal()">Upgrade</a> a tu plan.
                </div>

                <div class="row">
                    <div class="col-sm-6">
                    <div class="form-group">
                        <h6><b>Precio en USD</b></h6>
                        <input type="number" v-model="precio" class="form-control" placeholder="Precio del Proyecto" required/>
                    </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <h6><b>Fecha Entrega</b></h6>
                            <input type="text" :value="fechaFormat(fechaCierre)" class="form-control" disabled/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <h6><b>Mi fecha de inicio</b></h6>
                            <input type="date" v-model="tiempoEntrega" class="form-control" required/>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <h6><b>Vigencia de tu propuesta</b></h6>
                            <input id="dateVigencia" type="date" v-model="vigencia" class="form-control" placeholder="ej. 90" required/>
                        </div>
                    </div>
                </div>
                <!--NO BORRAR-->
                <div class="form-group">
                    <h6><b>Describe tus fortalezas para ejecutar este proyecto:</b> <br> <small>(Máximo 140 caracteres)</small> </h6>
                    <textarea class="form-control" rows="2" v-model="propuesta" maxlength="140"
                        required placeholder="¿Que te hace un buen candidato para este trabajo?">
                    </textarea>
                </div>

                <div class="form-group">
                    <h6><b>Adjuntos</b></h6>
                    <input type="file" class="form-control" @change="addFile">
                </div>

                <span class="warning-font">
                    *Debe tener en consideración que, dependiendo del método que elija para recibir el pago de sus servicios, las
                    Instituciones involucradas en la transacción, pueden aplicar algunas tarifas que son independientes a nuestros
                    servicios y le serán descontadas cuando estas apliquen.
                </span> <br>

                </div>
                <div class="modal-footer">
                    <a style="font-size:12px" :href="urlWeb+ '/assets/pdf/politicaCargosTarifas.pdf'" class="mr-auto" target="_blank">
                            Ver Politicas de Cargos y Tarifas
                    </a>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="submit"  v-if="!cargandoSegundoBtn" class="btn orange" :disabled='membresia.valida == 0 || membresia.vencido == 0'>
                        Aceptar
                    </button>
                    <button class="btn orange" v-else disabled>
                        Cargando...
                    </button>
                </div>
            </form>
            </div>
        </div>
        </div>
   </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import $ from 'jquery'

export default {
mixins: [ globalFunctions ],
name: 'NuevaPropuesta',
props:['idProyecto', 'type'],
data () {
    return {
        precio: "",
        tiempoEntrega: "",
        propuesta: "",
        divisa: "USD",
        vigencia: null,
        idEmpresa : '',
        fechaCierre : '',
        postulacion: 'false', //para saber si se ya se postulo
        membresia: '',
        cargando: false,
        selectedFile: null,
        fileName: '',
        cargandoSegundoBtn: false,
        nombre: ''
    }
},
computed:{
    ...mapState(['url','urlWeb'])
},
methods: {
addFile(event){
        this.selectedFile = event.target.files[0];
        this.fileName = this.selectedFile.name;
},
validarMembresia(idProyecto) {
    this.cargando = true;

    let data = {
        idProyecto,
        idUsuario: localStorage.userID
    }

    this.axios.post(this.url + 'getValidaMembresia.php', data).then((responce) =>{
        this.membresia = responce.data[0];
        this.validarPostulacion();
    });

},
validarPostulacion(){

    //Verficiar si ya se postulo
    let user = {
        id: localStorage.userID,
        idEmp: this.idProyecto,
        flag: '7'
    }

    this.axios.post(this.url + 'consultasBasicas.php', user).then((responce) =>{
        if(responce.data != null){
            this.postulacion = true;
        }

        if(this.postulacion != true){
            $("#exampleModal").modal("show");
        } else {
            this.$swal.fire('Ya has enviado una propuesta anteriormente para este proyecto.')
        }

        this.cargando = false;
    });
},
altaPropuesta(e) {
    this.cargandoSegundoBtn = true;
    e.preventDefault();

    if(this.tiempoEntrega >= this.fechaCierre){
      this.msjError("Fecha de Inicio es mayor o igual a la fecha de Entrega.");
      this.cargandoSegundoBtn = false
      return;
    }

    if(this.vigencia > this.fechaCierre){
      this.msjError("Fecha de Vigencia es mayor a la fecha de Entrega");
      this.cargandoSegundoBtn = false
      return;
    }

    if(this.precio <= 0){
      this.msjError("Precio debe ser mayor a $0");
      this.cargandoSegundoBtn = false
      return;
    }

    if(this.selectedFile != null) //Validar que sea pdf
    {
        let archivo = this.selectedFile.name;
        let index = archivo.length;
        index = index - 4;
        var res = archivo.substr(index, 4);

        res.toLowerCase();

        if(res != '.pdf'){
            this.msjError("Solo se acepta archivos con formato PDF");
            this.cargandoSegundoBtn = false
            return;
        }

        //Insertar en Server
        const fd = new FormData();
        fd.append('file',this.selectedFile, this.selectedFile.name);

        this.axios.post(this.url + 'altaArchivo.php', fd, {
            header:{
                'Content-Type': 'multipart/form-data'
            }
        }).then((responce) =>{
            if(responce.data.res == '200'){
                let fileName = responce.data.nombre;
                this.altaPropuestaInfo(fileName);
            }else{
                alert("Error");
            }
        });
    }else{
        this.altaPropuestaInfo();
    }
},
altaPropuestaInfo(newFileName=null){

    let data = {
      precio: this.precio,
      tiempo1: this.tiempoEntrega,
      tiempo2: this.fechaCierre,
      propuesta: this.propuesta,
      idEmp: this.idProyecto,
      idPropuesta: localStorage.userID,
      divisa: this.divisa,
      vigencia: this.vigencia,
      newFileName: newFileName,
      fileName: this.fileName,
    };

    this.axios.post(this.url + "altaPropuesta.php", data).then((responce) => {
      if (responce.data > 0) {
        this.cargandoSegundoBtn = false;
        this.precio = "";
        this.tiempoEntrega = "";
        this.propuesta = "";
        this.vigencia = "";
        this.enviarCorreo(13, 'Recepción de propuesta', this.idProyecto, responce.data); //responce.data retorna el ultimo id de propuesta
        this.msjOk("Tu propuesta ha sido enviada");
        $("#exampleModal").modal("hide");
        this.$router.push('/Proyectos');
      } else {
        this.msjError('La fecha de inicio del proyecto no debe ser menor a la actual');
        this.cargandoSegundoBtn = false;
      }
    });
},
cerrarModal(){
    $("#exampleModal").modal('hide');
    this.$router.push({ name: 'pagos'});
},

/*vercargosytarifas(){
    $("#exampleModal").modal('hide');
    this.$router.push({ name: 'pagos'});
},*/

getData(){
    let data = {
        flag:1,
        id:this.idProyecto
    }

    this.axios.post(this.url + 'getProyectos.php', data).then((responce) =>{
        this.nombre = responce.data[0].titulo_proyecto;
        this.fechaCierre = responce.data[0].fecha_cierre;
    })
}
},
mounted() {

    this.getData();
    var maxDate = this.addFiveDaysToday();

    $('#exampleModal').on('shown.bs.modal', function (e) {
        $('#dateVigencia').attr('min', maxDate);
    });

},
}
//Fin Script
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NuevaPropuesta.vue